const errorPage = {
  fr: {
    errorPage: {
      title: 'Oups! Un problème est survenu',
      continue: 'Continuer',
    },
  },
  en: {
    errorPage: {
      title: 'Oops! Something went wrong',
      continue: 'Continue',
    },
  },
};

export default errorPage;
